<template>
  <main>
    <HeroSection />
    <AboutSection />
    <OpinionsSection />
    <SimplifySection />
  </main>
</template>

<script>
import AboutSection from "./AboutSection.vue";
import HeroSection from "./HeroSection.vue";
import OpinionsSection from "./OpinionsSection.vue";
import SimplifySection from "./SimplifySection.vue";

export default {
  components: {
    HeroSection,
    AboutSection,
    OpinionsSection,
    SimplifySection,
  },
};
</script>

<style lang="scss">
.container {
  color: $orange;
}
</style>
